import styled from "styled-components";
import { Link as LinkS } from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';
import { FaTimes } from "react-icons/fa";
export const SidebarContainer = styled.aside`
    position:fixed;
    z-index:999;
    width:100%;
    height:100%;
    background:#111221;
    display:grid;
    align-items:center;
    top:0;
    left:0;
    transition:0.3s ease-in-out;
     opacity:${({isOpen}) =>(isOpen ? '100%' : '0')};
    top: ${({isOpen}) => (isOpen ? '0' : '-100%')}; 
    
`;
export const CloseIcon = styled(FaTimes)`
    color:#E8175D;
`;
export const Icon = styled.div`
    position:absolute;
    top:1.2rem;
    right:1.5rem;
    background: transparent;
    font-size:2rem;
    cursor:pointer;
    outline:none;
`;

export const SidebarWrapper = styled.div`
    color:#fff;
`;
export const SidebarMenu = styled.ul`
    display:grid;
    grid-template-columns:1fr;
    grid-template-rows: repeat(6,80px);
    text-align:center;
    @media screen and (max-width:480px){
        grid-template-rows: repeat(6,80px);
    }
    @media screen and (max-width:375px){
        grid-template-rows: repeat(6,60px);
    }
`;
export const SidebarLi = styled.li`
    display:block;
`;
export const SidebarLink = styled(LinkS)`
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:1.5rem;
    text-decoration:none;
    list-style:none;
    transition: 0.2s ease-in-out;
    text-decoration:none;
    color:#E8175D;
    cursor:pointer;
    margin-top:3rem;
    &:hover{
        color:#fff;
        transition:0.2s ease-in-out;
    }
    @media screen and (max-width:360px){
        font-size:1.5rem;
    }
`;
export const SidebarBtnWarp = styled.div`
    display:flex;
    justify-content:center;
`;
export const SidebarRoute = styled(LinkR)`
    border-radius: 50px;
    background:#e8175d;
    white-space:nowrap;
    padding:16px 64px;
    color:#fff;
    font-size:16px;
    outline:none;
    border:none;
    cursor:pointer;
    transition: all 0.2s ease-in-out;
    text-decoration:none;
    &:hover{
        transition: all 0.2s ease-in-out;
        background: #fff;
        color:#010606;
    }
`;